import $ from 'jquery';

// https://wistia.com/support/developers/player-api

window._wq = window._wq || [];

_wq.push( {
	id: '_all',
	onReady: function( video ) {
		const $wistiaBackgroundEmbed = $( video.elem() ).closest( '.js-wistia-background-embed' );
		if ( $wistiaBackgroundEmbed.length ) {
			if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
				// desktop
				video.bind( 'play', function() {
					$wistiaBackgroundEmbed[0].style.opacity = 1;
				} );
			} else {
				// mobile
				video.remove();
				video = null;
			}
		}
	}
} );
